import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import PhotoCapture from '../../../components/photo-capture/photo-capture';
import type { ReceivedImagePayload } from '../../../types';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import DesktopCameraPermission from './desktop-camera-permission';
import useCameraPermission from './hooks/use-camera-permission';
const FACE_OUTLINE_TO_WIDTH_RATIO = 0.7;
const DesktopSelfie = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.desktop-selfie"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const [state, send] = useIdDocMachine();
  const {
    requirement,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  const permissionState = useCameraPermission();
  let t1;
  if ($[1] !== send) {
    t1 = payload => send({
      type: "receivedImage",
      payload
    });
    $[1] = send;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onComplete = t1;
  let t2;
  if ($[3] !== send) {
    t2 = () => {
      send({
        type: "cameraStuck"
      });
    };
    $[3] = send;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCameraStuck = t2;
  let t3;
  if ($[5] !== allowPdf || $[6] !== handleCameraStuck || $[7] !== hasBadConnectivity || $[8] !== onComplete || $[9] !== permissionState || $[10] !== requirement || $[11] !== t) {
    t3 = permissionState === "allowed" ? <PhotoCapture autocaptureKind="face" cameraKind="front" deviceKind="desktop" allowPdf={allowPdf} requirement={requirement} hasBadConnectivity={hasBadConnectivity} outlineHeightRatio={FACE_OUTLINE_TO_WIDTH_RATIO} outlineWidthRatio={FACE_OUTLINE_TO_WIDTH_RATIO} title={{
      camera: t(_temp),
      preview: t(_temp2)
    }} subtitle={{
      camera: t(_temp3)
    }} onComplete={onComplete} onCameraStuck={handleCameraStuck} /> : <DesktopCameraPermission permissionState={permissionState} />;
    $[5] = allowPdf;
    $[6] = handleCameraStuck;
    $[7] = hasBadConnectivity;
    $[8] = onComplete;
    $[9] = permissionState;
    $[10] = requirement;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default DesktopSelfie;
function _temp($) {
  return $.header.title.camera;
}
function _temp2($_0) {
  return $_0.header.title.preview;
}
function _temp3($_1) {
  return $_1.header.subtitle.camera;
}